/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import {TaskResourceService} from "@well/delivery-libs/task-management/resource-services";
import {Observable} from "rxjs";
import {JsonApiListResourceMetadataBase, JsonApiResource} from "@irian-ro/abstract-resource";
import {TaskViewVoModel} from "@well/delivery-libs/task-management/domain";

@Injectable()
export class TaskListService {

  constructor(private taskResourceService: TaskResourceService) {
  }

  loadTaskListFromSegment(segmentSelectedRsUuid: string): Observable<JsonApiResource<TaskViewVoModel[], JsonApiListResourceMetadataBase>> {
    return this.taskResourceService.getTaskListForSegment(segmentSelectedRsUuid);
  }

}
